import { render, staticRenderFns } from "./LiquidacionesBackoffice.vue?vue&type=template&id=36cbaeaa&scoped=true&"
import script from "./LiquidacionesBackoffice.vue?vue&type=script&lang=js&"
export * from "./LiquidacionesBackoffice.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionesBackoffice.vue?vue&type=style&index=0&id=36cbaeaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbaeaa",
  null
  
)

export default component.exports